import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import './Hero.css';
import CallToAction from './CallToAction';

const Hero = () => {
  const [slide, setSlide] = useState(1);

  const handleSlide = (direction) => {
    switch (direction) {
      case 'prev':
        if (slide === 1) {
          setSlide(3);
        } else {
          setSlide(slide - 1);
        }
        break;
      case 'next':
        if (slide === 3) {
          setSlide(1);
        } else {
          setSlide(slide + 1);
        }
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className="hero">
        <div className="hero-inner" style={{ transform: `translateX(${(slide - 1) * -100}vw)` }}>
          <div className="hero-slide slide1">
            <div className="container">
              <div className="row">
                <div className="col col-12 col-lg-8 col-xl-6">
                  <h1>
                    Your <span className="text-primary">IT Partner</span> <br />
                    in CEE
                  </h1>
                  <h2>Dedicated to support your business in digital transformation</h2>
                  <Link to="/" className="btn btn-secondary" style={{ margin: '30px 65px 15px auto' }}>
                    Our solutions{' '}
                    <span className="chev">
                      <i className="bi bi-chevron-right"></i>
                    </span>
                  </Link>
                </div>
                <div className="col"></div>
              </div>
            </div>
          </div>
          <div className="hero-slide slide2">
            <div className="container">
              <div className="row">
                <div className="col">
                  <h1>Talented consultants</h1>
                  <h2>We look forward to getting to know you and to helping you take your company to new level</h2>
                  <Link to="/" className="btn btn-secondary" style={{ margin: '30px auto 15px 0px' }}>
                    Our services{' '}
                    <span className="chev">
                      <i className="bi bi-chevron-right"></i>
                    </span>
                  </Link>
                </div>
                <div className="col"></div>
              </div>
            </div>
          </div>
          <div className="hero-slide slide3">
            <div className="container">
              <div className="row">
                <div className="col">
                  <h1>
                    Thought <span className="text-primary">leadership</span>
                  </h1>
                  <h2>With over 10 years of experience helping businesses to find comprehensive solutions</h2>
                  <div style={{ margin: '30px 0 15px 0' }}>
                    <Link to="/" className="btn btn-secondary" style={{ margin: '0 30px 0 0' }}>
                      Our company{' '}
                      <span className="chev">
                        <i className="bi bi-chevron-right"></i>
                      </span>
                    </Link>
                    <Link to="/" className="btn btn-primary" style={{ margin: '0 30px 0 0' }}>
                      Contact us{' '}
                      <span className="">
                        <i className="bi bi-chevron-right"></i>
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="col"></div>
              </div>
            </div>
          </div>
        </div>
        <span className="navi slide-left" onClick={() => handleSlide('prev')}>
          <i className="bi bi-chevron-double-left"></i>
        </span>
        <span className="navi slide-right" onClick={() => handleSlide('next')}>
          <i className="bi bi-chevron-double-right"></i>
        </span>
      </div>
      <CallToAction />
    </>
  );
};

export default Hero;
